import { Cubby } from "../stores/Cubby";
import { validateInvoice } from "./stringValidation";

export const handleInvoiceChange = (
  value: string,
  cubby: Cubby,
  setError: (value: string | null) => void,
  setLoadingOverlayVisible: (value: boolean) => void
) => {
  const invoice = value;
  cubby.setInvoiceForPayment(invoice);
  if (!validateInvoice(invoice)) {
    setError("Invalid Lightning invoice");
  } else {
    setLoadingOverlayVisible(true);
    setTimeout(() => {
      setLoadingOverlayVisible(false);
    }, 3000);
    setError(null);
  }
};

export const handlePaymentAmountChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  cubby: Cubby,
  setPaymentAmountError: (value: string | null) => void,
  setPaymentAmount: (value: string) => void,
  setBtcAmount: (value: string) => void
) => {
  const value = event.currentTarget.value;
  const amount = parseInt(value, 10);
  const maxAmount = cubby.highestOutboundChannelBalance;

  if (amount < 1) {
    setPaymentAmountError("Payment amount must be at least 1 satoshi.");
  } else if (amount > maxAmount) {
    setPaymentAmountError(
      `Payment amount must not exceed ${maxAmount.toLocaleString()} satoshis.`
    );
  } else {
    setPaymentAmountError(null);
  }

  setPaymentAmount(value);
  const btcValue = (amount / 100000000).toFixed(8);
  setBtcAmount(isNaN(Number(btcValue)) || btcValue === "0" ? "" : btcValue);
};

export const handleMaxFeeChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  cubby: Cubby,
  paymentAmount: string,
  setMaxFeeError: (value: string | null) => void,
  setMaxFee: (value: string) => void
) => {
  const value = event.currentTarget.value;

  const amountToPay =
    parseInt(paymentAmount) || cubby.lastDecodedPayRequest.data.safe_tokens;
  const maxFeeValue = parseInt(value, 10);

  if (maxFeeValue < 0) {
    setMaxFeeError("Max fee must not be less than 0.");
  } else if (maxFeeValue > amountToPay / 2) {
    setMaxFeeError(
      "Max fee must not exceed half the value of the amount to pay."
    );
  } else {
    setMaxFeeError(null);
  }

  setMaxFee(value);
};

export const handlePathFindingTimeoutChange = (
  event: React.ChangeEvent<HTMLInputElement>,
  setPathFindingTimeoutError: (value: string | null) => void,
  setPathFindingTimeout: (value: string) => void
) => {
  const value = event.currentTarget.value;
  const timeoutValue = parseInt(value, 10);

  if (timeoutValue < 5) {
    setPathFindingTimeoutError(
      "Pathfinding timeout must not be less than 5 seconds."
    );
  } else if (timeoutValue > 240) {
    setPathFindingTimeoutError(
      "Pathfinding timeout must not exceed 240 seconds."
    );
  } else {
    setPathFindingTimeoutError(null);
  }

  setPathFindingTimeout(value);
};

export const isTwoFaSatisfied = (
  shouldShow2FAForm: boolean,
  twoFACode: string,
  twoFAError: string | null
): boolean => {
  if (!shouldShow2FAForm) {
    return true;
  }

  if (shouldShow2FAForm && !twoFACode) {
    return false;
  }

  if (shouldShow2FAForm && twoFACode && twoFACode.length > 0 && twoFAError) {
    return false;
  }

  return true;
};

export const isPayButtonDisabled = (
  shouldShow2FAForm: boolean,
  twoFACode: string,
  twoFAError: string | null,
  maxFeeError: string | null,
  error: string | null,
  paymentAmountError: string | null,
  safe_tokens: number,
  paymentAmount: string
): boolean => {
  if (safe_tokens === 0 && paymentAmount === "0") {
    return true;
  }

  if (!isTwoFaSatisfied(shouldShow2FAForm, twoFACode, twoFAError)) {
    return true;
  }
  if (maxFeeError || error || paymentAmountError) {
    return true;
  }
  return false;
};
